<div class="p-a-10 left p-a-5-s p-a-5-m p-l-6-s">
  <div class="m-b-5">
    <div class="flex flex-justify-between flex-middle">
      <span class="flex flex-middle s1">
        @if (icon) {
          <i
            style="font-size: 1.2rem;"
            class="m-r-3 inline-flex"
          [ngClass]="'icon-' + icon"></i>
        }
        @if (title) {
          <h5 class="fw-medium"
            >{{title | translate}}
          </h5>
        }
      </span>
      @if (link) {
        <a
          [routerLink]="link"
        class="p1 button-inline">{{(linkCopy || 'Edit') | translate}}</a>
      }
      <ng-content select="[section2cta]"></ng-content>
    </div>
    @if (subtitle) {
      <p
      class="p1 col-12">{{subtitle}}</p>
    }
  </div>
  <ng-content></ng-content>
</div>
